import React from 'react';
import { Grid, Typography, Box, Container, Chip, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const HIGHLIGHTS = [
  'Real-time slot availability with zero waiting time',
  'Simple dashboards for staff, services and schedules',
  'Trusted by salons and parlours across India',
];

const AboutSection = () => {
  return (
    <Box
      component="section"
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        background: 'linear-gradient(180deg, #f5faff 0%, #e6f2fb 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">
          {/* Left side text */}
          <Grid item xs={12} md={6}>
            <Chip
              label="About us"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: '#135F97',
                backgroundColor: 'rgba(32,133,216,0.12)',
              }}
            />

            <Typography
              variant="h3"
              component="h2"
              sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 2.5 }}
            >
              Beauty bookings, <span className="gradient-text">reimagined</span>
            </Typography>

            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2, lineHeight: 1.8 }}>
              Cizlot is revolutionizing the beauty and wellness industry by connecting salon owners
              with customers through our innovative platform.
            </Typography>

            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3, lineHeight: 1.8 }}>
              Our mission is to empower salon owners with the tools they need to succeed while
              providing customers with a seamless booking experience.
            </Typography>

            <Stack spacing={1.5}>
              {HIGHLIGHTS.map((item) => (
                <Box key={item} display="flex" alignItems="flex-start" gap={1.25}>
                  <CheckCircleIcon sx={{ color: '#2085D8', fontSize: 22, mt: '2px' }} />
                  <Typography variant="body1" sx={{ color: 'text.primary' }}>
                    {item}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Grid>

          {/* Right side images */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={2.5}>
              {['img3jpg.jpg', 'img5.jpg', 'img4.jpg'].map((img, index) => (
                <Grid item xs={6} sm={4} md={index === 0 ? 12 : 6} key={img}>
                  <Box
                    sx={{
                      width: '100%',
                      aspectRatio: index === 0 ? { xs: '1 / 1', md: '16 / 9' } : '1 / 1',
                      overflow: 'hidden',
                      borderRadius: '20px',
                      boxShadow: '0 18px 40px rgba(19,95,151,0.14)',
                      transition: 'transform 0.35s ease',
                      '&:hover': { transform: 'scale(1.02)' },
                    }}
                  >
                    <Box
                      component="img"
                      src={`/${img}`}
                      alt={`Cizlot ${index + 1}`}
                      loading="lazy"
                      decoding="async"
                      sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutSection;
